import React from 'react';

const RequiredField = ({ label }) => (
    <label>
        {label} <span style={{ color: 'red' }}>*</span>
    </label>
);

export default RequiredField;